module.exports = __webpack_public_path__ + "img/cave173.0db2e3dc.jpg";